import React from 'react';
import { Modal, Text, Divider, Row, Column, Button, Layout } from '@dls/web';
import useTranslation from '@/hooks/useTranslation';

const AlertModal = ({ visible, handleLogout, continueSession }) => {
  const { t } = useTranslation();

  return (
    <Modal visible={visible} backdropClosable={false} closable={false}>
      <Modal.Content>
        <Layout.Stack>
          <Text type="sectionTitle">{t('ALERT_MESSAGE_TEXT')}</Text>
          <Text>{t('INACTIVITY_DETAIL_TEXT')}</Text>
          <Divider />
          <Row>
            <Column>
              <Button secondary fullWidth data-testid="logout-btn" onClick={() => handleLogout()}>
                {t('ACTION_BUTTON_LOGOUT')}
              </Button>
            </Column>
            <Column>
              <Button secondary={false} fullWidth data-testid="continue-session-btn" onClick={() => continueSession()}>
                {t('CONTINUE_SESSION_BUTTON_TEXT')}
              </Button>
            </Column>
          </Row>
        </Layout.Stack>
      </Modal.Content>
    </Modal>
  );
};

export default AlertModal;